<app-nav></app-nav>
<div class="container" innerHTML="{{ 'privacy' | translate }}"></div>
<app-footer></app-footer>
